import styled from '@emotion/styled'
import { AnimatedTitle } from 'app/components/Common/Animation/AnimatedTitle'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles } from 'app/theme'
import React, { memo } from 'react'

import { Props as ServiceProps, Service } from './Service'

export interface Props {
  services: ServiceProps[]
  title?: string
}

export const ServicesList = memo(function ServicesList({
  services,
  title,
}: Props) {
  if (services.length < 1) {
    return null
  }

  return (
    <Container>
      <Wrapper row space="between" wrap>
        <LeftSide>{title ? <Title text={title} /> : null}</LeftSide>

        <Services row wrap>
          {services.map((item, index) => (
            <FadeInUp delay={index * 0.1} key={index}>
              <Service {...item} />
            </FadeInUp>
          ))}
        </Services>
      </Wrapper>
    </Container>
  )
})

const Container = styled.section`
  margin: 9.75rem auto;
  padding: 0 5vw;

  @media (max-width: 1199px) {
    margin: 5.25rem auto;
    padding: 0 2rem;
  }
`

const Wrapper = styled(FlexBox)`
  border-top: 0.0625rem solid
    ${({ theme }) => theme.colors.variants.primaryDark};
  padding-top: 2.25rem;

  @media (max-width: 1199px) {
    display: block;
    border: 0;
    padding-top: 0;
  }
`

const LeftSide = styled.div``

const Title = styled(AnimatedTitle)`
  ${styles.label}

  margin-top: 0.75rem;

  @media (max-width: 1199px) {
    margin-top: 0;
  }
`

const Services = styled(FlexBox)`
  max-width: 66.667vw;
  flex: 1;

  > div {
    display: flex;
    align-items: center;
    width: 33.333%;
    margin-top: 0.75rem;
  }

  @media (max-width: 1199px) {
    max-width: none;

    > div {
      width: 50%;
    }
  }

  @media (max-width: 767px) {
    > div {
      width: 100%;
    }
  }
`
